;(function () {
  function fixReploAriaRoles() {
    const reploLinks = document.querySelectorAll('a[role="link"][data-rid]')
    reploLinks.forEach(link => link.removeAttribute('role'))
  }

  function fixDuplicateIDs() {
    const seen = new Set()
    const allWithIDs = document.querySelectorAll('[id]')
    allWithIDs.forEach((el, index) => {
      const id = el.id
      if (seen.has(id)) {
        // Rename duplicate with index suffix
        el.id = `${id}-${index}`
      }
      seen.add(el.id)
    })
  }

  function applyFixes() {
    fixReploAriaRoles()
    fixDuplicateIDs()
  }

  // Run immediately
  applyFixes()

  // Run after a short delay
  setTimeout(applyFixes, 1000)

  // Run periodically for 45 seconds
  let retryCount = 0
  const maxRetries = 15
  const intervalId = setInterval(() => {
    applyFixes()
    retryCount++
    if (retryCount >= maxRetries) {
      clearInterval(intervalId)
    }
  }, 3000)
})()
